module.exports = __webpack_public_path__ + "mp.fec806e5ccb0f18ffcad.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/mp.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/mp.svg
// module chunks = styles